import { getRouterBasename } from './routes/utils'

const basename = getRouterBasename()
const basePath = basename === '/' ? '' : basename

const settings = {
  client_id: KEYCLOAK_CLIENT,
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }${basePath}/authentication/callback`,
  response_type: 'code',
  scope: 'openid profile',
  authority: `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`,
  silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }${basePath}/authentication/silent_callback`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`,
  automaticSilentRenew: true,
  loadUserInfo: true,
}

export default settings
